<form [formGroup]="myForm">

  <div style="border-bottom: 2px solid #525f7f; text-align: center; padding-top: 25px; font-size: 19px;">
    <h3>Advt Credit Note Details</h3>
  </div>

  <div class="row p-4">

    <!-- Row 1 -->
    <div class="col-md-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Advt Name</mat-label>
        <input matInput formControlName="advtname" readonly />
      </mat-form-field>
    </div>

    <div class="col-md-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Credit Note No</mat-label>
        <input matInput formControlName="CreitVC" readonly />
      </mat-form-field>
    </div>

    <div class="col-md-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Credit Note Date</mat-label>
        <input matInput formControlName="Vcdate" readonly />
      </mat-form-field>
    </div>

    <!-- Row 2 -->
    <div class="col-md-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Creation Date</mat-label>
        <input matInput formControlName="crndate" readonly />
      </mat-form-field>
    </div>

    <div class="col-md-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Invoice Number</mat-label>
        <input matInput formControlName="invcnum" readonly />
      </mat-form-field>
    </div>

    <div class="col-md-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Invoice Date</mat-label>
        <input matInput formControlName="invcdate" readonly />
      </mat-form-field>
    </div>

    <!-- Row 3 -->
    <div class="col-md-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Invoice Amount</mat-label>
        <input matInput formControlName="invcamt" readonly />
      </mat-form-field>
    </div>

    <div class="col-md-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Credit Note Amt</mat-label>
        <input matInput formControlName="CRamt" readonly />
      </mat-form-field>
    </div>

    <div class="col-md-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Representative Name</mat-label>
        <mat-select formControlName="Repname">
          <mat-option *ngFor="let item of repname" [value]="item.rep_name">
            {{ item.rep_name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- TDS / Other / Total -->
    <div class="col-md-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>TDS Amt</mat-label>
        <input matInput type="number" formControlName="tdsAmt" />
      </mat-form-field>
    </div>

    <div class="col-md-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Other Credit Amt</mat-label>
        <input matInput type="number" formControlName="otherAmt" />
      </mat-form-field>
    </div>

    <div class="col-md-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Total Credit Amt</mat-label>
        <input matInput [value]="totalCreditAmount" readonly />
      </mat-form-field>
    </div>

    <!-- Remark -->
    <div class="col-md-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Remark</mat-label>
        <input matInput formControlName="remark" />
      </mat-form-field>
    </div>

  </div>

  <!-- Buttons -->
  <div class="text-end pe-5" style="float: right; padding-right: 90px;">
    <button *ngIf="showSaveButton" mat-raised-button color="primary" [disabled]="totalCreditAmount === 0"
      (click)="getModaldata()">
      Save
    </button>

    <button mat-button mat-dialog-close class="ms-2">
      Close
    </button>
  </div>

</form>